module.exports = __webpack_public_path__ + "static/media/iris_together.6c916471.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iris_together.png
// module id = 203
// module chunks = 17